// extracted by mini-css-extract-plugin
module.exports = {"border":"FloatingPanel_border__vpPxd","extra":"FloatingPanel_extra__iX9ca","content":"FloatingPanel_content__HywF8"};